import { SociodemographicCriteria, TSociodemographicCriteriaValues } from '@definitions';
import { getSociodemographicResource } from '@api';
import { getStateKeyByValue } from '@utils';
import { ResourceSociodemographicApiType } from '@api/types';
import { useEffect, useState } from 'react';

export const useSociodemographicResources = () => {
  const [resources, setResources] = useState<ResourceSociodemographicApiType[]>([]);

  useEffect(() => {
    getSociodemographicResource().then((result = []) => {
      setResources(result);
    });
  }, []);

  const getResource = (type: TSociodemographicCriteriaValues): ResourceSociodemographicApiType =>
    resources.find(
      (res) => res.socioDemographicCriteria === getStateKeyByValue(SociodemographicCriteria, type),
    );

  const getResourceOptions = (type: TSociodemographicCriteriaValues) => {
    const resource = getResource(type);
    const { values = {} } = resource || {};
    return Object.keys(values).map((key) => ({
      label: key,
      criteria: resource.socioDemographicCriteria,
      value: values[key],
    }));
  };

  return {
    getResourceOptions,
  };
};
